import { SurveyDataItem } from '@diversioteam/diversio-ds'
import React, { useState } from 'react'
import { RatingType } from '@diversioteam/diversio-ds/dist/components/core/ProfilesBarChart/profilesBarChart.types'
import { SurveyChartCard } from '@diversioteam/diversio-ds'

import { useGetPulseSurveyResults } from 'hooks/pulseSurveys/useGetPulseSurveyResults'
import { usePulseSurveys } from 'hooks/usePulseSurveys'
import { PulseSurveysError } from '../Error'

import * as S from './results.styles'
import { ResultsSummaryCard } from './ResultsSummary'
import { ResultsSkeleton } from './skeleton'
import { FreeTextQuestion } from './FreeTextQuestion'

export const Results = () => {
    const [isColorBlindModeEnabled, setIsColorBlindModeEnabled] = useState(false)

    const { activePulseSurvey } = usePulseSurveys()
    const surveyUUID = activePulseSurvey?.uuid || ''

    const {
        data: resultsData,
        isLoading: resultsDataIsLoading,
        isError,
    } = useGetPulseSurveyResults({ surveyUUID }, { enabled: !!surveyUUID })

    const totalResponses = resultsData?.total || 0
    const responseData = resultsData?.data || []

    const handleColorBlindModeToggle = () => {
        setIsColorBlindModeEnabled((prev) => !prev)
    }

    if (resultsDataIsLoading) {
        return <ResultsSkeleton />
    }

    if (isError) {
        return <PulseSurveysError />
    }

    return (
        <S.ResultsWrapper>
            <ResultsSummaryCard
                title={totalResponses === 1 ? 'Total Response' : 'Total Responses'}
                totalResponses={totalResponses}
                handleColorBlindModeToggle={handleColorBlindModeToggle}
                isColorBlindModeEnabled={isColorBlindModeEnabled}
            />

            {responseData.map((response) => {
                const questionType = response.question_info.question_type ?? 'multiple_choice'
                const isFreeText = ['short_answer', 'paragraph'].includes(response.question_info.question_type)
                const questionId = response.question_info.id

                if (isFreeText) {
                    return (
                        <FreeTextQuestion
                            key={questionId}
                            surveyUUID={surveyUUID}
                            questionId={questionId}
                            questionTitle={response.question_info.title}
                            questionType={questionType}
                            colorBlindMode={isColorBlindModeEnabled}
                        />
                    )
                }

                const chartData: SurveyDataItem[] =
                    response.stats?.map((stat) => ({
                        name: stat?.choice,
                        value: stat?.count === 'N/A' ? 0 : stat?.count,
                    })) || []

                return (
                    <SurveyChartCard
                        key={questionId}
                        data={chartData}
                        colorBlindMode={isColorBlindModeEnabled}
                        totalResponses={response?.total}
                        questionTitle={response.question_info.title}
                        questionType={questionType}
                        ratingType={response.question_info.display_sub_type as RatingType}
                    />
                )
            })}
        </S.ResultsWrapper>
    )
}
